import { render, staticRenderFns } from "./eshop-item.vue?vue&type=template&id=34985fc6&scoped=true"
import script from "./eshop-item.vue?vue&type=script&lang=js"
export * from "./eshop-item.vue?vue&type=script&lang=js"
import style0 from "./eshop-item.vue?vue&type=style&index=0&id=34985fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34985fc6",
  null
  
)

export default component.exports